// extracted by mini-css-extract-plugin
export default {"element":"Checkbox_element__zrIui","box":"Checkbox_box__Zp6MB","active":"Checkbox_active__nPp2u","label":"Checkbox_label__sSA2o","disabled":"Checkbox_disabled__GqRwU"};